import SEO from '../../components/base/SEO';
import SchemaOrg from '../../components/base/SchemaOrg';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import CommunityHeroSection from './components/CommunityHeroSection';
import TeachersSection from './components/TeachersSection';
import TechEducationSection from './components/TechEducationSection';
import LocalNetworkSection from './components/LocalNetworkSection';

export default function CommunityPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const educationalOrgSchema = {
    '@context': 'https://schema.org',
    '@type': 'EducationalOrganization',
    name: 'Daygreen 기술 교육 센터',
    description: '봉제 기술 교육을 통해 120명 이상의 자립을 지원하는 교육 기관',
    url: `${siteUrl}/community`,
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Seoul',
      addressCountry: 'KR',
    },
    areaServed: 'KR',
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '공동체',
    description: '봉제 기술 교육과 자립 지원 네트워크',
    url: `${siteUrl}/community`,
    inLanguage: 'ko-KR',
  };

  return (
    <>
      <SEO
        title="공동체 - Daygreen | 봉제 기술 교육과 자립 지원 네트워크"
        description="Daygreen은 봉제 기술 교육을 통해 120명 이상의 자립을 지원했습니다. 전문 강사진과 함께하는 체계적인 교육 프로그램과 지역 네트워크를 소개합니다."
        keywords="봉제 기술 교육, 자립 지원, 기술 교육 프로그램, 공동체 네트워크, 사회적 교육, 직업 훈련, 기술 자립"
        canonical="/community"
        ogType="website"
      />
      <SchemaOrg schema={[educationalOrgSchema, webPageSchema]} />
      <div className="min-h-screen bg-white">
        <Navbar />
        <CommunityHeroSection />
        <TeachersSection />
        <TechEducationSection />
        <LocalNetworkSection />
        <Footer />
      </div>
    </>
  );
}